export const formatDurationLabel = (seconds: number, unit: "seconds" | "minutes" | "hours"): string => {
  const value = unit === "seconds" ? seconds : unit === "minutes" ? seconds / 60 : seconds / 3600;

  return `${value.toLocaleString("de-DE", { maximumFractionDigits: 2 })} ${
    unit === "seconds" ? "Sekunden" : unit === "minutes" ? "Minuten" : "Stunden"
  }`;
};
